/* Wildtera — policy pages (/policies/*).
 *
 * The text on these pages is Shopify's markup, pasted into Settings →
 * Policies, so nothing in it carries a class or an id. This file only adds
 * presentation, and the page reads in full without it:
 *
 *   - every <h2> gets an id, and "On this page" lists them;
 *   - the opening "In short" heading and its list become one panel;
 *   - the "Last updated…" line is set as a label rather than a paragraph;
 *   - the contents list marks the section being read. A colour change, no
 *     movement: it is navigation, and navigation should not perform.
 *
 * Loaded only on policy pages, from layout/theme.liquid.
 */
(function () {
  'use strict';

  var body =
    document.querySelector('.shopify-policy__body .rte') ||
    document.querySelector('.shopify-policy__body');
  if (!body) return;

  var wide = window.matchMedia('(min-width: 990px)');

  function slug(text, used) {
    var words = text
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    var base = words ? 'policy-' + words : 'policy-section';
    var id = base;
    var n = 2;
    while (used[id] || document.getElementById(id)) {
      id = base + '-' + n;
      n += 1;
    }
    used[id] = true;
    return id;
  }

  /* "Last updated: …" opens both policy documents. */
  var first = body.firstElementChild;
  if (first && first.tagName === 'P' && /^\s*last updated/i.test(first.textContent)) {
    first.classList.add('wt-policy__updated');
  }

  /* The short version: the heading and everything up to the next heading,
     gathered into one tan panel so it reads as a summary rather than as the
     first chapter. */
  var headings = Array.prototype.slice.call(body.querySelectorAll(':scope > h2'));
  headings.forEach(function (h2) {
    if (h2.textContent.trim().toLowerCase() !== 'in short') return;
    var panel = document.createElement('section');
    panel.className = 'wt-policy__short';
    h2.parentNode.insertBefore(panel, h2);
    var node = h2;
    while (node && !(node !== h2 && node.tagName === 'H2')) {
      var next = node.nextElementSibling;
      panel.appendChild(node);
      node = next;
    }
  });

  /* Contents. */
  var toc = document.querySelector('[data-wt-policy-toc]');
  var contents = document.querySelector('[data-wt-policy-contents]');
  var used = {};
  var chapters = headings.filter(function (h2) {
    return h2.textContent.trim().toLowerCase() !== 'in short';
  });
  var links = [];

  headings.forEach(function (h2) {
    if (!h2.id) h2.id = slug(h2.textContent.trim(), used);
  });

  if (toc && contents && chapters.length > 1) {
    chapters.forEach(function (h2) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.className = 'wt-policy__toc-link';
      a.textContent = h2.textContent.trim();
      li.appendChild(a);
      toc.appendChild(li);
      links.push(a);
    });
    contents.hidden = false;

    /* Open beside the text on a wide screen, folded above it on a narrow one,
       where an open list of eight headings would push the policy a screen
       down. */
    var setOpen = function () {
      contents.open = wide.matches;
    };
    setOpen();
    if (wide.addEventListener) wide.addEventListener('change', setOpen);

    toc.addEventListener('click', function (event) {
      if (!event.target.closest('a')) return;
      if (!wide.matches) contents.open = false;
    });
  }

  /* The section being read: the last heading to have passed just under the
     sticky header. Measured on scroll, at most once a frame. */
  if (links.length) {
    var LINE = 140;
    var ticking = false;
    var update = function () {
      ticking = false;
      var passed = null;
      chapters.forEach(function (h2) {
        if (h2.getBoundingClientRect().top <= LINE) passed = h2.id;
      });
      links.forEach(function (a) {
        if (passed && a.getAttribute('href') === '#' + passed) {
          a.setAttribute('aria-current', 'true');
        } else {
          a.removeAttribute('aria-current');
        }
      });
    };
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  }
})();
